import { Card, Col, Input, List, Row, Tag } from "antd";
import { Typography } from "antd";

const { Text, Paragraph } = Typography;

const getRandom = (list) => {
  const index = Math.floor(Math.random() * list.length);
  return list[index];
};

const colors = ["processing", "magenta", "red", "volcano", "green", "orange"];

function Project({ project }) {
  return (
    <Card bordered>
      <Row>
        <Col span={12} style={{ padding: 3 }}>
          <Input addonBefore="Name" value={project.name} />
        </Col>
        <Col span={12} style={{ padding: 3 }}>
          <Input addonBefore="Course" value={project.course_details} />
        </Col>
      </Row>
      <Row style={{ marginTop: 6 }}>
        <Col span={12} style={{ padding: 3 }}>
          <Input addonBefore="Location" value={project.location} />
        </Col>
        <Col span={12} style={{ padding: 3 }}>
          <Input addonBefore="Range" value={project.date_range} />
        </Col>
      </Row>
      <Row style={{ marginTop: 6 }}>
        <Col span={16} style={{ padding: 3 }}>
          <List
            header={<Text strong>Description</Text>}
            bordered
            dataSource={[project.description]}
            renderItem={(item) => (
              <List.Item>
                <Paragraph style={{ textAlign: "start", margin: 0 }}>
                  {item}
                </Paragraph>
              </List.Item>
            )}
          />
        </Col>
        <Col span={8} style={{ padding: 3 }}>
          <List
            header={<Text strong>Skills</Text>}
            bordered
            dataSource={[project.skills]}
            renderItem={(item) => (
              <List.Item>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                >
                  {item.map((skill, i) => (
                    <Tag
                      style={{ margin: 2 }}
                      key={i}
                      color={getRandom(colors)}
                    >
                      {skill}
                    </Tag>
                  ))}
                </div>
              </List.Item>
            )}
          />
        </Col>
      </Row>
    </Card>
  );
}

export default Project;
